import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { MyfileModel } from 'src/app/core/models/myfile/myfile.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { TableConfigService } from 'src/app/core/services/table-config.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { EmailTemplateListService } from 'src/app/core/services/list-services/email-template-list.service';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { EmailTemplateListConfig } from './email-templates-list.config';
import { GlobalComponent } from 'src/app/global-component';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { EmailTemplateModalService } from 'src/app/core/services/modal-services/email-template-modal.service';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { EmailTemplateBaseModel } from 'src/app/core/models/emailTemplates/email-template.model.ts';

@Component({
  selector: 'app-email-templates-list',
  templateUrl: './email-templates-list.component.html',
  styleUrls: ['./email-templates-list.component.scss']
})
export class EmailTemplatesListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  override listItemsObservable!: Observable<MyfileModel[]>;

  configItemsObservable!: Observable<TableConfigurationModel[]>;
  //Security Operations of the current User
  securityPermissionInvoiceUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreateInvoice);

  protected override searchPlaceHolderText: string = "Search fby name";

  constructor(
    protected emailTemplateModalService: EmailTemplateModalService,
    public emailsListService: EmailTemplateListService,
    protected tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
    protected override toasterNotificationService: ToasterNotificationService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  ngOnInit(): void {

    this.tableConfig = new EmailTemplateListConfig();
    this.configItemsObservable = this.tableConfigService.resultItems$;

    const subscrConfig = this.configItemsObservable.subscribe(result => {

      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));

        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.emailsListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.emailsListService.resultItems$;
    this.total = this.emailsListService.total$;
    this.isLoading = this.emailsListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.emailsListService.totalRecords;
      this.serviceData.pageSize = this.emailsListService.pageSize;
      this.serviceData.pageIndex = this.emailsListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

  }

  openModel(model: EmailTemplateBaseModel) {
    this.emailTemplateModalService.openModal(model);
    var sub: Subscription = this.emailTemplateModalService.modelChanged.subscribe((result: any) => {
      if (result) {
        this.serviceSort(this.emailsListService, '', '');
      }
      sub.unsubscribe();

    });
  }

  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.emailsListService, '', '');
    } else {
      this.serviceSort(this.emailsListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  ngOnDestroy() {
    this.listItems = undefined;
    this.clearSearch(this.emailsListService);
    this.clearSearch(this.tableConfigService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    if (rowAction.actionIdSelected == ActionIdEnum.Edit) {
      this.openModel(rowAction.model)
    }
  }
  override buttonActionSelected(buttonAction: any): void {
    if (buttonAction == ButtonIdEnum.CreateNew) {
      this.openModel(new EmailTemplateBaseModel);
    }
  }
  override filterSelected(filterSelected: ListFilterModel): void {
    throw new Error('Method not implemented.');
  }


}
